import { jsx as _jsx } from "react/jsx-runtime";
import * as S from "./styled.js";
export const Skeleton = ({ animation ='pulse' , className , height , style , variant ='text' , width , color , opacity , ...rest })=>/*#__PURE__*/ _jsx(S.Skeleton, {
        "data-testid": "Skeleton",
        animation: animation,
        className: className,
        variant: variant,
        $color: color,
        opacity: opacity,
        style: {
            width,
            height,
            ...style
        },
        ...rest
    });
export default Skeleton;

//# sourceMappingURL=index.js.map